import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


const initialState = {
  status: null,
  data: [],
};

export const getShopifyMarkets = createAsyncThunk(
  "getShopifyMarkets",
  async (data) => {
    try {
      const response = await fetch(`/api/getShopifyMarkets/${data.configid}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch shopify markets");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getShopifyMarkets",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getShopifyMarkets.pending, (state) => {
        state.status = "Shopify markets loading";
        state.message = null;
      })
      .addCase(getShopifyMarkets.fulfilled, (state, action) => {
        state.status = "Shopify markets loaded";
        state.data = action.payload.data.data;
      })
      .addCase(getShopifyMarkets.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
